import React from 'react';
import PropTypes from 'prop-types';

import CardDialog from '~/components/CardDialog';
import Button from '~/components/core/Atomic/Buttons/Button';
import Grid from '~/components/core/Atomic/Grid/Grid';
import Typography from '~/components/core/Atomic/Typography';

const PolicyModeToggleDialog = ({ open, onClose, onConfirm, isTogglingToDemo, currentUrl, targetUrl, loading }) => {
  const title = isTogglingToDemo ? 'Switch to Demo Mode?' : 'Switch to Production Mode?';

  return (
    <CardDialog
      open={open}
      onClose={onClose}
      isDialog
      title={title}
      maxWidth="sm"
      fullWidth
      footerActions={
        <Grid container spacing={2} justify="flex-end">
          <Grid item>
            <Button variant="outlined" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color={isTogglingToDemo ? 'secondary' : 'primary'}
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? 'Switching...' : isTogglingToDemo ? 'Switch to Demo Mode' : 'Switch to Production Mode'}
            </Button>
          </Grid>
        </Grid>
      }
    >
      {/* Warning/Info Content */}
      <Grid container direction="column" spacing={2}>
        <Grid item>
          {isTogglingToDemo ? (
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Typography variant="body2" style={{ color: '#f57c00', fontWeight: 500 }}>
                  ⚠️ This will override your policy server configuration:
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" component="div">
                  <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
                    <li>Policy searches will use mock/demo data</li>
                    <li>All policy API calls will be redirected</li>
                    <li>Current production settings will be erased</li>
                  </ul>
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" style={{ marginTop: '8px' }}>
                  You can switch back to production mode at any time.
                </Typography>
              </Grid>
            </Grid>
          ) : (
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Typography variant="body2" style={{ color: '#388e3c', fontWeight: 500 }}>
                  ✅ This will restore your production policy server:
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" component="div">
                  <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
                    <li>Policy searches will use live production data</li>
                    <li>All policy API calls will use your configured endpoint</li>
                    <li>Demo mode settings will be saved for future use</li>
                  </ul>
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>

        {/* URL Change Display (if provided) */}
        {currentUrl && targetUrl && (
          <Grid item>
            <Grid container direction="column" spacing={1}>
              <Grid item>
                <Typography variant="body2" style={{ fontWeight: 500 }}>
                  URL Change:
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" style={{ fontSize: '12px', color: '#666' }}>
                  FROM: {currentUrl}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" style={{ fontSize: '12px', color: '#666' }}>
                  TO: {targetUrl}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </CardDialog>
  );
};

PolicyModeToggleDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isTogglingToDemo: PropTypes.bool.isRequired,
  currentUrl: PropTypes.string,
  targetUrl: PropTypes.string,
  loading: PropTypes.bool,
};

PolicyModeToggleDialog.defaultProps = {
  currentUrl: null,
  targetUrl: null,
  loading: false,
};

export default PolicyModeToggleDialog;
